import { createContext } from 'react';

// eslint-disable-next-line @nx/workspace/no-restricted-imports-clone
import { ResponsiveValue } from '@chakra-ui/react';

export interface IDescendantsVariantContext {
  variant?: ResponsiveValue<string>;
}

export const DescendantsVariantContext =
  createContext<IDescendantsVariantContext>({
    variant: undefined,
  });
